import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group h-full p-6 bg-slate-800/50 hover:bg-slate-800/80 border border-slate-800 hover:border-primary-500/50 rounded-2xl transition-all duration-300 hover:shadow-xl hover:shadow-primary-500/10 hover:-translate-y-1" }
const _hoisted_2 = { class: "flex items-start space-x-4" }
const _hoisted_3 = { class: "flex-shrink-0 p-3 bg-slate-900 rounded-xl group-hover:bg-slate-800 transition-colors border border-slate-700/50" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "font-semibold text-slate-100 group-hover:text-primary-400 transition-colors mb-1" }
const _hoisted_6 = { class: "text-sm text-slate-400 line-clamp-2 leading-relaxed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "h-8 w-8 object-contain",
          src: _ctx.tool.icon,
          alt: _ctx.tool.name + ' Logo'
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.tool.name), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.tool.description), 1)
      ])
    ])
  ]))
}